<template>
  <div id="mapBox" class="amap-page-container">
    <el-amap vid="amapDemo" :zoom="zoom" :center="center" :scrollWheel='scrollWheel' class="amap-demo">
      <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :visible="marker.visible" :icon='marker.icon' :draggable="marker.draggable" :vid="index" :key='index'></el-amap-marker>
      <el-amap-info-window :position="currentWindow.position" :content="currentWindow.content" :showShadow='currentWindow.showShadow' :visible="currentWindow.visible" :offset="currentWindow.offset"></el-amap-info-window>
    </el-amap>
  </div>
</template>

<script>
import labelIcon from '@/assets/footer/mapIcon.png'
import AMap from 'vue-amap'
var amapManager = new AMap.AMapManager()
export default {
  name: 'Map',
  data: function () {
    return {
      amapManager,
      center: [120.01090039227293, 30.28638467154789],
      lng: 0,
      lat: 0,
      loaded: false,
      zoom: 18,
      scrollWheel: false,
      markers: [{
        position: [120.01090039227293, 30.28638467154789],
        visible: true,
        draggable: false,
        icon: labelIcon
      }],
      currentWindow: {
        position: [120.01090039227293, 30.28638467154789],
        content: '<div style="background-color: #fff;padding: 15px;width: 380px;box-sizing: border-box;"><div style="width:100%;margin: 0 auto;font-size: 18px;color: rgba(19, 20, 19, 1);font-weight: bold;padding-bottom:6px;text-align: left;border-bottom: 3px solid RGBA(12, 137, 24, 1);">浙江电马云车科技有限公司</div><div style="margin-top: 10px;color: rgba(89, 89, 89, 1);font-size: 14px;text-align: left;text-align: left;">地址：杭州市余杭区仓前街道海智中心1幢8层801室</div><div style="margin-top: 10px;color: rgba(89, 89, 89, 1);font-size: 14px;text-align: left;">电话：<span style="color: RGBA(19, 20, 19, 1);font-weight: bold;">400-1518-788</span></div><div style="margin-top: 10px;color: rgba(89, 89, 89, 1);font-size: 14px;text-align: left;">邮箱：market@opencar.cc</div><div style="margin-top: 10px;color: rgba(89, 89, 89, 1);font-size: 14px;text-align: left;">工作时间：周一至周五（9:00AM-18:00PM）</div></div>',
        events: {},
        offset: [0, -30],
        visible: true
      }
    }
  }
}
</script>

<style>
#mapBox {
  width: 100%;
  height: 460px;
}
.amap-info-close{
  display: none!important;
}
.amap-info-outer, .amap-menu-outer{
 box-shadow: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Map.vue